export class ScreenShake {
  private shakeAmount: number = 0;
  private shakeDuration: number = 0;
  private shakeTime: number = 0;
  private offsetX: number = 0;
  private offsetY: number = 0;

  shake(amount: number, duration: number): void {
    this.shakeAmount = amount;
    this.shakeDuration = duration;
    this.shakeTime = 0;
  }

  update(deltaTime: number): void {
    if (this.shakeTime < this.shakeDuration) {
      this.shakeTime += deltaTime;
      const progress = this.shakeTime / this.shakeDuration;
      const currentAmount = this.shakeAmount * (1 - progress);
      
      this.offsetX = (Math.random() - 0.5) * 2 * currentAmount;
      this.offsetY = (Math.random() - 0.5) * 2 * currentAmount;
    } else {
      this.offsetX = 0;
      this.offsetY = 0;
    }
  }

  getOffset(): { x: number; y: number } {
    return { x: this.offsetX, y: this.offsetY };
  }

  isShaking(): boolean {
    return this.shakeTime < this.shakeDuration;
  }

  clear(): void {
    this.shakeAmount = 0;
    this.shakeDuration = 0;
    this.shakeTime = 0;
    this.offsetX = 0;
    this.offsetY = 0;
  }
}